import { Popover } from "@mui/material";
import React from "react";
import ViewReverse from "./ViewReverse";
import Text from "./Text";
import { fontSizes } from "../constants/constants";
import { ReactSVG } from "react-svg";
import icons from "../constants/icons";
import NotificationListItem from "./NotificationListItem";
import { useNavigate } from "react-router";

const NotificationModal = ({ isOpen, onClose, targetEl, onAlertClick }) => {
  const navigate = useNavigate();

  const handleSeeAll = () => {
    navigate("/notifications");
    onClose();
  };

  return (
    <Popover
      open={isOpen}
      anchorEl={targetEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
    >
      <div className="w-80 sm:w-96">
        <ViewReverse
          className={"w-full justify-between p-5 border-b border-b-grey"}
        >
          <Text text="Notifications" size={fontSizes.h14} />

          <ViewReverse
            className={"gap-1 cursor-pointer"}
            onClick={onAlertClick}
          >
            <ReactSVG src={icons.warning} />
            <Text text="Alerts" size={fontSizes.h14} color="text-primary" />
          </ViewReverse>
        </ViewReverse>

        <NotificationListItem
          title={"Notification 1"}
          description={"TAWADUL: Bid went up by 1.23%"}
          isRead={true}
        />
        <NotificationListItem
          title={"Notification 2"}
          description={"TAWADUL: Bid went up by 1.23%"}
        />
        <NotificationListItem
          title={"Notification 3"}
          description={"TAWADUL: Bid went up by 1.23%"}
        />
        <NotificationListItem
          title={"Notification 4"}
          description={"TAWADUL: Bid went up by 1.23%"}
        />
        <NotificationListItem
          title={"Notification 5"}
          description={"TAWADUL: Bid went up by 1.23%"}
        />

        <div className="py-4 flex justify-center items-center">
          <Text
            text="See All"
            color="text-primary"
            className={"cursor-pointer"}
            onClick={handleSeeAll}
          />
        </div>
      </div>
    </Popover>
  );
};

export default NotificationModal;
